import * as flights from '../../flights';

export class StopDurationFilter {
    min: number;
    max: number;
    rangeMin: number;
    rangeMax: number;

    constructor(flights: flights.FlightModel[]) {
        let minStop = 0;
        let maxStop = 0;

        flights.forEach(f => {
            f.legs.forEach(l => {
                for (let i = 0; i < l.segments.length - 1; i++) {
                    const stopBeginTime = l.segments[i].arrivalDate;
                    const stopEndTime = l.segments[i + 1].departureDate;
                    const d = stopEndTime.diff(stopBeginTime, 'minute');

                    if (!minStop || minStop > d) {
                        minStop = d;
                    }

                    if (!maxStop || maxStop < d) {
                        maxStop = d;
                    }
                }
            });
        });

        if (minStop > 0
            && maxStop > 0
            && minStop !== maxStop) {
            this.min = minStop;
            this.max = maxStop;
        } else {
            this.min = 0;
            this.max = 0;
        }

        this.rangeMin = this.min;
        this.rangeMax = this.max;
    }

    get touched(): boolean {
        return this.rangeMin !== this.min || this.rangeMax !== this.max;
    }

    clear() {
        this.rangeMin = this.min;
        this.rangeMax = this.max;
    }

    check(flight: flights.FlightModel): boolean {
        if (this.min !== this.max && (this.min !== this.rangeMin || this.max !== this.rangeMax)) {
            if (flight.stopDuration[0] == 0 && flight.stopDuration[1] == 0) {
                // Filter out direct flights
                return false;
            } else {
                if (flight.stopDuration[0] < this.rangeMin) {
                    return false;
                }

                if (flight.stopDuration[1] > this.rangeMax) {
                    return false;
                }
            }
        }

        return true;
    }
}
